
// Enhanced input validation utilities
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) && 
         email.length <= 254 && // RFC 5321 limit
         email.length >= 5 && // Minimum reasonable email length
         !email.includes('..') && // No consecutive dots
         !email.startsWith('.') && 
         !email.endsWith('.');
};

export const sanitizeInput = (input: string): string => {
  // Remove potential XSS characters and normalize
  return input.trim().toLowerCase().replace(/[<>'"&]/g, '');
};

export const sanitizeEmailInput = (email: string): string => {
  // More conservative sanitization for email
  return email.trim().toLowerCase().replace(/[^a-z0-9@._-]/g, '');
};

export const isValidMetadata = (metadata: Record<string, any>): boolean => {
  // Check for potential XSS or injection attempts
  const dangerousKeys = ['__proto__', 'constructor', 'prototype'];
  return !Object.keys(metadata).some(key => 
    dangerousKeys.includes(key) || 
    typeof metadata[key] === 'function'
  );
};

// Password strength validation function
export function validatePasswordStrength(password: string): { isValid: boolean; errors: string[] } {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}
